import React, { useState } from 'react';
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import GAEventTracking from '@components/tracking/GAEventTracking';

function FontSettings() {
  const [radioValue, setRadioValue] = useState(false);
  const gaEventTracker = GAEventTracking('Settings');

  const changeFont = selectedValue => {
    document.documentElement.className = '';
    if (selectedValue === 'small') {
      document.documentElement.classList.add('root-text-sm');
      localStorage.setItem('font', 'small');
      gaEventTracker('Change Font Size', 'Font Size Small');
    }
    if (selectedValue === 'medium') {
      document.documentElement.classList.add('root-text-md');
      localStorage.setItem('font', 'medium');
      gaEventTracker('Change Font Size', 'Font Size Medium');
    }
    if (selectedValue === 'large') {
      document.documentElement.classList.add('root-text-lg');
      localStorage.setItem('font', 'large');
      gaEventTracker('Change Font Size', 'Font Size Large');
    }
  };
  return (
    <>
      <h5>Font Size</h5>
      <div className="list mt-1">
        <ToggleButtonGroup
          name="changeFrontSize"
          type="radio"
          onChange={changeFont}
        >
          <ToggleButton
            className={document.documentElement.classList.contains('root-text-sm') ? 'btn-default waves-effect waves-themed active' : 'btn-default waves-effect waves-themed'}
            title="Small"
            value="small"
            checked={radioValue === 'small' || document.documentElement.classList.contains('root-text-sm')}
            onChange={e => {
              setRadioValue(e.currentTarget.value);
            }}
          >
            <i className="fas fa-text fa-sm" />
          </ToggleButton>
          <ToggleButton
            className={document.documentElement.classList.contains('root-text-md') ? 'btn-default waves-effect waves-themed active' : 'btn-default waves-effect waves-themed'}
            title="Medium"
            value="medium"
            checked={radioValue === 'medium' || document.documentElement.classList.contains('root-text-md')}
            onChange={e => {
              setRadioValue(e.currentTarget.value);
            }}
          >
            <i className="fas fa-text" />
          </ToggleButton>
          <ToggleButton
            className={document.documentElement.classList.contains('root-text-lg') ? 'btn-default waves-effect waves-themed active' : 'btn-default waves-effect waves-themed'}
            title="Large"
            value="large"
            checked={radioValue === 'large' || document.documentElement.classList.contains('root-text-lg')}
            onChange={e => {
              setRadioValue(e.currentTarget.value);
            }}
          >
            <i className="fas fa-text fa-lg" />
          </ToggleButton>
        </ToggleButtonGroup>
      </div>
    </>
  );
}

export default FontSettings;
